<template>
    <div class="admin-tab">
        <wb-datatable
                class="apps-table"
                v-bind="tableAppProps"
                @addEmit="openDialog"
                @editEmit="openDialog"
                @deleteEmit="openConfirmDialog"
                :customControls="[
        {
          icon: 'add',
          name: 'Register at baas',
          handler: (row) => {
            openAdditionalDialog(row, 'baas');
          }
        },
        {
          icon: 'add',
          name: 'Register audience',
          handler: (row) => {
            registerAudienceVert(row);
          }
        },
        {
          icon: 'delete',
          name: 'Delete audience',
          handler: (row) => {
            deleteAudienceVert(row);
          }
        },
      ]"
                :searchKey="'Name'"
        ></wb-datatable>
        <md-dialog ref="algDialog">
            <md-dialog-title>{{isNew ? 'Create algorithm' : 'Update algorithm'}}</md-dialog-title>
            <md-dialog-content>
                <form>

                </form>
            </md-dialog-content>
        </md-dialog>
        <md-dialog ref="dialog">
            <md-dialog-title>{{isNew ? 'Create app' : 'Update app'}}</md-dialog-title>

            <md-dialog-content>
                <form v-if="app">
                    <md-input-container>
                        <label>Name</label>
                        <md-input v-model="app.Name" :disabled="!createNewAppGroup"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Category</label>
                        <md-input v-model="app.Category" :disabled="!createNewAppGroup"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Image</label>
                        <md-input v-model="app.image" :disabled="!createNewAppGroup"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>URL</label>
                        <md-input v-model="app.url"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Environment</label>
                        <multiselect id="environments"
                                     v-model="app.environment"
                                     :options="environments"
                                     placeholder="Select environment"/>
                    </md-input-container>
                    <div>
                        <md-switch id="createNewAppGroup" v-model="createNewAppGroup"></md-switch>
                        <label for="createNewAppGroup">Create new App Group</label>
                    </div>
                    <md-input-container>
                        <multiselect id="app-groups"
                                     v-model="selectedAppGroup"
                                     :options="appGroups"
                                     :label="'Name'"
                                     :disabled="createNewAppGroup"
                                     placeholder="Select App Group"/>
                    </md-input-container>
                    <md-input-container v-if="!isNew">
                        <label>Audience ID</label>
                        <md-input v-model="app.audienceId"></md-input>
                    </md-input-container>
                    <md-input-container v-if="!isNew">
                        <label>Audience Parameter</label>
                        <md-input v-model="app.audienceParameter"></md-input>
                    </md-input-container>
                </form>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
                <md-button class="md-primary"
                           :disabled="app && app.registerBaas && baasValidMessage && Object.keys(baasValidMessage).length > 0"
                           @click="closeDialog(true)">{{isNew ? 'Create' : 'Update'}}
                </md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog ref="confirmDialog">
            <md-dialog-title>Are you sure you would like to remove this app?</md-dialog-title>

            <md-dialog-content>
                App will permanently be removed from the database. <br>
                <template v-if="app && app.audienceId">
                    Would you like to remove an audience?
                    <md-switch v-model="deleteAnAudience" id="delete-audience" name="delete-audience">Delete an
                        audience
                    </md-switch>
                </template>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
                <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog ref="baasDialog">
            <md-dialog-title>Register baas algorithm</md-dialog-title>
            <md-dialog-content>
                <form v-if="app">
                    <template>
                        <md-input-container>
                            <label>Select algorithm</label>
                            <md-select v-model="algorithm" @change="algorithmSelected">
                                <md-option v-for="algorithm in baasAlgorithms" :value="algorithm">{{algorithm.name}}
                                </md-option>
                            </md-select>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.name">
                                {{baasValidMessage.name}}</p>
                            <label>Name</label>
                            <md-input v-model="newAlgData.name" :disabled="!!algorithm"></md-input>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.category">
                                {{baasValidMessage.category}}</p>
                            <label>Select category</label>
                            <md-select v-model="newAlgData.category" :disabled="!!algorithm && newAlgData.category">
                                <md-option v-for="cat in baasCategories" :value="cat">{{cat.name}}</md-option>
                            </md-select>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.service">
                                {{baasValidMessage.service}}</p>
                            <label>Select Maas service</label>
                            <md-select v-model="newAlgData.service" @change="maasServiceSelect">
                                <md-option v-for="service in services" :value="service">{{service.name}}</md-option>
                            </md-select>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.environment">
                                {{baasValidMessage.environment}}</p>
                            <label>Select environment</label>
                            <md-select v-model="newAlgData.environment">
                                <md-option v-for="env in baasEnvs" :value="env">{{env.name}}</md-option>
                            </md-select>
                        </md-input-container>
                        <div class="multiselect-container">
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.protocol">
                                {{baasValidMessage.protocol}}</p>
                            <label>Protocol</label>
                            <md-select v-model="newAlgData.protocol">
                                <md-option v-if="protocols" :value="protocol.tag" v-for="protocol in protocols">
                                    {{protocol.name}}
                                </md-option>
                            </md-select>
                        </div>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.invocationType">
                                {{baasValidMessage.invocationType}}</p>
                            <label>Invocation Type</label>
                            <md-select v-model="newAlgData.invocationType">
                                <md-option v-if="invocationTypes" :value="invocationType.tag"
                                           v-for="invocationType in invocationTypes">{{invocationType.name}}
                                </md-option>
                            </md-select>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.platform">
                                {{baasValidMessage.platform}}</p>
                            <label>Platform</label>
                            <md-select v-model="newAlgData.platform">
                                <md-option v-if="platforms" :value="platform.tag" v-for="platform in platforms">
                                    {{platform.name}}
                                </md-option>
                            </md-select>
                        </md-input-container>
                        <md-input-container>
                            <p class="validation-error" v-if="baasValidMessage && baasValidMessage.region">
                                {{baasValidMessage.region}}</p>
                            <label>Region</label>
                            <md-select v-model="newAlgData.region">
                                <md-option v-if="regionsForPlatforms" :value="regionForPlatform.tag"
                                           v-for="regionForPlatform in regionsForPlatforms">
                                    {{regionForPlatform.name}}
                                </md-option>
                            </md-select>
                        </md-input-container>
                        <md-switch v-model="newAlgData.reportInSlack" id="report-in-slack" name="report-in-slack">
                            Report In Slack
                        </md-switch>
                        <md-switch v-model="newAlgData.logProblem" id="log-problem" name="log-problem">
                            Log Problem
                        </md-switch>
                        <md-switch v-model="newAlgData.logResult" id="log-result" name="log-result">
                            Log Result
                        </md-switch>
                        <br/>
                        <md-switch v-model="newAlgData.logToPythia" id="log-to-pythia" name="log-to-pythia">
                            Log To Pythia
                        </md-switch>
                        <md-switch v-model="newAlgData.watched" id="watched" name="log-problem">
                            Watched
                        </md-switch>
                        <multiselect id="userAudiences"
                                     v-model="newAlgData.customerTag"
                                     :options="customerTags"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"
                                     @remove="removeTag"
                                     placeholder="Customer Tag"/>
                        <!--  <md-input-container>
                           <label>Algorithm Key</label>
                           <md-input v-model="newAlgData.algorithmKey"></md-input>
                         </md-input-container>
                         <md-input-container>
                           <label>Algorithm Group Key</label>
                           <md-input v-model="newAlgData.algorithmGroupKey"></md-input>
                         </md-input-container> -->
                    </template>
                    <!--  <

                     <template v-if="app.protocol">
                       <md-input-container v-for="(property, index) in app.protocol.properties">
                         <p class="validation-error" v-if="baasValidMessage && baasValidMessage[property.name]">{{baasValidMessage[property.name]}}</p>
                         <label>Protocol's {{property.name}}</label>
                         <md-input v-model="app.protocol.properties[index].value"></md-input>
                       </md-input-container>
                     </template>


                     <md-input-container>
                       <p class="validation-error" v-if="baasValidMessage && baasValidMessage.timeToLive">{{baasValidMessage.timeToLive}}</p>
                       <label>Time To Live</label>
                       <md-input v-model="app.timeToLive" type="number"></md-input>
                     </md-input-container>


                      -->
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="closeAdditionalDialog(false, 'baas')">Cancel</md-button>
                <md-button class="md-primary" :disabled="baasValidMessage && Object.keys(baasValidMessage).length > 0"
                           @click="closeAdditionalDialog(true, 'baas')">Create
                </md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog ref="maasDialog">
            <md-dialog-title>Register at maas service</md-dialog-title>
            <md-dialog-content>
                <form v-if="app">
                    <div>
                        <md-switch v-model="app.configureManually" id="configureManually" name="configureManually">
                            Configure manually
                        </md-switch>
                    </div>
                    <multiselect id="services"
                                 v-if="services"
                                 v-model="app.selectedService"
                                 :disabled="app.configureManually"
                                 :options="services"
                                 :label="'name'"
                                 placeholder="Select service"/>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="closeAdditionalDialog(false, 'maas')">Cancel</md-button>
                <md-button class="md-primary" @click="closeAdditionalDialog(true, 'maas')">Create</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import wbDataTable from 'WBDataTable';
    import {mapActions, mapGetters} from 'vuex';
    import {required} from 'vuelidate/lib/validators';
    import Multiselect from 'vue-multiselect';
    import managedata from "../../helpers/managedata";

    export default {
        name: 'AdminApps',
        components: {
            'wb-datatable': wbDataTable,
            'multiselect': Multiselect,
        },
        data() {
            return {
                algorithm: null,
                newAlgData: {},
                customerTags: [],
                app: null,
                isNew: false,
                tableAppProps: {
                    dataext: [],
                    columns: null,
                    hasControls: true,
                    allowCreation: true,
                    disableSearch: false,
                    pagination: {
                        size: 50
                    },
                },
                tableAppColumns: [
                    {name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false, width: '20px'},
                    {name: 'Name', displayName: 'App Name', visible: true, type: 'string', isEditable: false},
                    {name: 'environment', displayName: 'Environment', visible: true, type: 'string', isEditable: false},
                    {name: 'Category', displayName: 'App Category', visible: true, type: 'string', isEditable: false},
                    {name: 'wbAppGroup', displayName: 'App Group', visible: true, type: 'string', isEditable: false},
                    {
                        name: 'image',
                        displayName: 'Image',
                        visible: true,
                        type: 'string',
                        isEditable: false,
                        width: '80px'
                    },
                    {name: 'url', displayName: 'Url', visible: true, type: 'string', isEditable: false, width: '150px'},
                    {
                        name: 'audienceParameter',
                        displayName: 'Audience parameter',
                        visible: true,
                        type: 'string',
                        isEditable: false
                    },
                ],
                environments: ['Develop', 'Test', 'Acceptance', 'Production'],
                deleteAnAudience: false,
                appGroups: [],
                selectedAppGroup: null,
                createNewAppGroup: true,
            }
        },
        validations: {},
        watch: {
            'newAlgData.platform': function (val) {
                this.$store.dispatch('getRegionsForPlatform', val);
            },
            'newAlgData.category': function (val) {
                this.generateAlgorithmKey();
                if (this.algorithm)
                    this.generateAlgorithmGroupKey();
            },
            'newAlgData': function (val) {
                this.generateAlgorithmKey();
                if (this.algorithm)
                    this.generateAlgorithmGroupKey();
            },
            'newAlgData.environment': function (val) {
                this.generateAlgorithmKey();
            },
            selectedAppGroup(val) {
                if (val) {
                    this.app.Name = val.Name;
                    this.app.Category = val.Category;
                    this.app.image = val.image;
                } else if (this.isNew) {
                    this.app.Name = '';
                    this.app.Category = '';
                    this.app.image = '';
                }
            },
            createNewAppGroup() {
                if (this.app.wbAppGroupId) {
                    this.selectedAppGroup = this.appGroups.find(group => group.id === this.app.wbAppGroupId)
                } else {
                    this.selectedAppGroup = null;
                }
            }
        },
        computed: {
            ...mapGetters([
                'apps',
                'audiences',
                'baasAlgorithms',
                'protocols',
                'invocationTypes',
                'platforms',
                'regionsForPlatforms',
                'services',
                'baasEnvs',
                'baasCategories',
            ]),
            baasValidMessage: function () {
                let res = {};
                if (!this.newAlgData) return res;

                if (!this.newAlgData.name) {
                    res.name = 'field is required';
                }
                if (!this.newAlgData.category) {
                    res.category = 'field is required';
                }
                if (!this.newAlgData.service) {
                    res.service = 'field is required';
                }
                if (!this.newAlgData.environment) {
                    res.environment = 'field is required';
                }
                if (!this.newAlgData.invocationType) {
                    res.invocationType = 'field is required';
                }
                if (!this.newAlgData.protocol) {
                    res.protocol = 'field is required';
                }
                if (!this.newAlgData.platform) {
                    res.platform = 'field is required';
                }
                if (!this.newAlgData.region) {
                    res.region = 'field is required';
                }
                return res;
            },
        },
        methods: {
            createBaasChange(val) {
                if (val) {
                    console.log(this.app)
                    this.newAlgData = {
                        name: this.app.Name,
                        environment: this.app.environment,
                        category: this.app.Category,
                        protocol: this.app.protocol,
                    };
                }
            },
            maasServiceSelect(val) {
                let index = this.platforms.findIndex(item => item.tag == val.platform);
                if (index > -1) {
                    this.newAlgData.platform = val.platform;
                    this.$store.dispatch('getRegionsForPlatform', val.platform);
                    this.$nextTick(() => {
                        this.newAlgData.region = val.region;
                        this.$forceUpdate();
                    })
                }
            },
            algorithmSelected(alg) {
                this.newAlgData = {
                    name: this.algorithm.name,
                    environment: this.algorithm.environment,
                    protocol: (this.algorithm.address) ? this.algorithm.address.protocol : null,
                    invocationType: this.algorithm.invocationType,
                    platform: this.algorithm.platform,
                    region: this.algorithm.region,
                    reportInSlack: this.algorithm.reportInSlack,
                    logProblem: this.algorithm.logProblem,
                    logResult: this.algorithm.logResult,
                    logToPythia: this.algorithm.logToPythia,
                    customerTag: this.algorithm.customerTag,
                    algorithmGroupKey: this.algorithm.algorithmGroupKey,
                };
            },
            generateAlgorithmKey() {
                this.newAlgData.algorithmKey = '';
                if (this.newAlgData.environment && this.newAlgData.category && this.algorithm.algorithmKey) {
                    this.newAlgData.algorithmKey = this.newAlgData.category.identifier + '.';
                    this.newAlgData.algorithmKey += this.newAlgData.environment.identifier + '.';
                    this.newAlgData.algorithmKey += this.algorithm.algorithmKey;
                }
            },
            generateAlgorithmGroupKey() {
                this.newAlgData.algorithmGroupKey = '';
                if (this.newAlgData.environment && this.newAlgData.category && this.algorithm.algorithmKey) {
                    this.newAlgData.algorithmKey = this.newAlgData.category.identifier + '.';
                    this.newAlgData.algorithmKey += '*.';
                    this.newAlgData.algorithmKey += this.algorithm.algorithmKey;
                }
            },
            getApps() {
                this.$store.dispatch('getApps')
                    .then(() => {
                        this.tableAppProps.dataext = [];
                        this.$nextTick(() => {
                            let tempData = JSON.parse(JSON.stringify(this.apps));
                            tempData = tempData.map(row => {
                                if (!row.algorithmId) {
                                    row.customClassName = 'haveNotAlgorithmId';
                                    if (row.audienceId) {
                                        row.customClassName = 'haveNotAlgorithmId audienceDelete';
                                    } else if (row.url) {
                                        row.customClassName = 'haveNotAlgorithmId audience';
                                    }
                                }
                                return row;
                            });
                            tempData.forEach(e => {
                                if (e.wbAppGroupId) {
                                    let appGroup = this.appGroups.find(group => group.id === e.wbAppGroupId);
                                    e.wbAppGroup = appGroup ? appGroup.Name : '';
                                }
                            });
                            this.tableAppProps.dataext = tempData.filter(item => !item.algorithmId);
                        });
                    })
            },
            addTag(newTag) {
                this.customerTags.push(newTag);
                if (!this.app.customerTag) {
                    this.app.customerTag = [];
                }
                this.app.customerTag.push(newTag);
            },
            removeTag(tag) {
                const positionTag = this.app.customerTag.indexOf(tag);
                this.app.customerTag.splice(positionTag, 1);

                const positionTags = this.app.customerTag.indexOf(tag);
                this.customerTags.splice(positionTags, 1);
            },
            openDialog(row) {
                if (row) {
                    this.isNew = false;
                    this.app = Object.assign({timeToLive: 330}, row);
                    if (row.wbAppGroupId) {
                        this.createNewAppGroup = false;
                        this.selectedAppGroup = this.appGroups.find(group => group.id === row.wbAppGroupId);
                    } else {
                        this.createNewAppGroup = true;
                    }
                } else {
                    this.isNew = true;
                    this.app = {
                        Name: null,
                        Category: null,
                        image: null,
                        url: null,
                        algorithmId: null,
                        configureManually: false,
                        customerTag: [],
                        protocol: null,
                        timeToLive: 330,
                        registerAudience: false,
                    };
                    this.createNewAppGroup = true;
                }
                this.$refs.dialog.open();
            },
            openAdditionalDialog(row, type) {
                if (row) {
                    this.isNew = false;
                    this.app = Object.assign({timeToLive: 330,}, row);
                } else {
                    this.isNew = true;
                    this.app = {
                        Name: null,
                        Category: null,
                        image: null,
                        url: null,
                        algorithmId: null,
                        configureManually: false,
                        customerTag: [],
                        protocol: null,
                        timeToLive: 330,
                        registerAudience: false,
                    };
                }
                if (type === 'baas') {
                    if ((this.protocols && this.protocols.length === 0) || !this.protocols)
                        this.$store.dispatch('getProtocols');
                    if ((this.invocationTypes && this.invocationTypes.length === 0) || !this.invocationTypes)
                        this.$store.dispatch('getInvocationTypes');
                    if ((this.platforms && this.platforms.length === 0) || !this.platforms)
                        this.$store.dispatch('getPlatforms');
                    this.$refs.baasDialog.open();
                } else if (type === 'maas') {
                    if ((this.services && this.services.length === 0) || !this.services)
                        this.$store.dispatch('getServices');
                    this.$refs.maasDialog.open();
                }
            },
            closeDialog(isSaved) {
                if (isSaved) {
                    if (this.createNewAppGroup) {
                        this.createAppGroup().then(res => {
                            this.app.wbAppGroupId = res.body.id;
                            this.createApp();
                        }).catch(err => {
                            console.log(err);
                        })
                    } else if (this.selectedAppGroup) {
                        this.app.wbAppGroupId = this.selectedAppGroup.id;
                        this.createApp();
                    } else {
                        this.createApp();
                    }
                } else {
                    this.$refs.dialog.close();
                    this.app = null;
                }
            },
            createAppGroup() {
                return managedata.createAppGroup({
                    Name: this.app.Name,
                    Category: this.app.Category,
                    image: this.app.image,
                });
            },
            createApp() {
                let actionName = this.isNew ? 'createApp' : 'updateApp';
                if (this.app.registerMaas || this.app.registerBaas) {
                    if (this.app.registerMaas) {
                        this.$store.dispatch('createMaasAlgorithm', this.app);
                    }
                    if (this.app.registerBaas) {
                        this.$store.dispatch('createBaasAlgorithm', this.newAlgData);
                    }
                    this.$store.dispatch(actionName, this.app)
                        .then(() => {
                            this.getApps();
                            this.$refs.dialog.close();
                            this.app = null;
                        });
                } else if (this.app.registerAudience) {
                    this.registerAudience(this.app.Name, this.app.environment, this.app.url)
                        .then(resp => {
                            console.log(resp);
                            this.app.audienceId = resp.body.id;
                            this.app.audienceParameter = resp.body.parameter;
                            this.$store.dispatch(actionName, this.app)
                                .then(() => {
                                    this.getApps();
                                    this.$refs.dialog.close();
                                    this.app = null;
                                });
                        })
                } else {
                    this.$store.dispatch(actionName, this.app)
                        .then(() => {
                            this.getApps();
                            this.$refs.dialog.close();
                            this.app = null;
                        });
                }
            },
            closeAdditionalDialog(isSaved, type) {
                this.app = null;
                this.$refs.maasDialog.close();
                this.$refs.baasDialog.close();
            },

            openConfirmDialog(row) {
                this.app = row;
                this.$refs.confirmDialog.open();
            },
            closeConfirmDialog(isConfirmed) {
                if (isConfirmed) {
                    if (this.deleteAnAudience) {
                        this.deleteAudience(this.app.audienceId, this.app.audienceParameter)
                            .then(() => {
                                this.$store.dispatch('deleteApp', this.app)
                                    .then(() => this.getApps())
                            });
                    } else {
                        this.$store.dispatch('deleteApp', this.app)
                            .then(() => this.getApps())
                    }
                    this.deleteAnAudience = false;
                }
                this.$refs.confirmDialog.close();
            },
            registerAudienceVert(row) {
                this.registerAudience(row.Name, row.environment, row.url)
                    .then(resp => {
                        row.audienceId = resp.body.id;
                        row.audienceParameter = resp.body.parameter;
                        this.$store.dispatch('updateApp', row)
                            .then(() => {
                                this.getApps();
                            });
                    })
                    .catch(err => console.log(err))
            },
            registerAudience(name, environment, audience) {
                return new Promise((resolve, reject) => {
                    managedata.createAuth0Audience({name, environment, audience})
                        .then(resp => resolve(resp))
                        .catch(err => reject(err))
                });
            },
            deleteAudienceVert(row) {
                this.deleteAudience(row.audienceId, row.audienceParameter)
                    .then(() => {
                        row.audienceId = '';
                        row.audienceParameter = '';
                        this.$store.dispatch('updateApp', row)
                            .then(() => {
                                this.getApps();
                            });
                    })
                    .catch(err => console.log(err))
            },
            deleteAudience(id, parameter) {
                return new Promise((resolve, reject) => {
                    managedata.deleteAuth0Audience([{key: 'id', value: id}, {key: 'parameter', value: parameter}])
                        .then(resp => resolve(resp))
                        .catch(err => reject(err))
                });
            },
            getAppGroups() {
                managedata.getAppGroups().then(res => {
                    this.appGroups = res.body;
                    this.getApps();
                })
            }
        },
        mounted() {
            this.tableAppProps.columns = this.tableAppColumns;
            this.getAppGroups();
            this.$store.dispatch('getServices');
        }
    }
</script>

<style scoped>
    .apps-table {
        width: 100%;
    }

    .admin-tab {
        display: flex;
    }

    .validation-error {
        position: absolute;
        right: 0;
        top: 0;
        margin: 0;
        text-transform: uppercase;
        font-size: 10px;
        text-align: right;
        color: red !important;
    }

    .multiselect-container {
        position: relative;
        padding-top: 20px;
    }
</style>

<style>
    .data-table-more-vert .haveNotAlgorithmId.audience:nth-child(2),
    .data-table-more-vert .haveNotAlgorithmId.audienceDelete:nth-child(3) {
        display: block !important;
    }

    .data-table-more-vert .haveNotAlgorithmId:not(.editControlButton):not(.deleteControlButton) {
        display: none;
    }

    .md-dialog-content {
        overflow: auto !important;
    }

    .admin-tab .md-table-header th.url,
    .admin-tab .md-table-body td.url {
        /*width: 600px;*/
    }

    .admin-tab .md-table-body td > div,
    .admin-tab .md-table-body td > div > div,
    .admin-tab .md-table-body td > div > div > div {
        white-space: inherit;
        width: inherit !important;
        word-wrap: break-word !important;
    }

    .admin-tab .md-table div.md-table-head-container,
    .admin-tab .md-table .md-table-cell .md-table-cell-container {
        padding: 6px 10px 6px 14px;
    }
</style>



// WEBPACK FOOTER //
// AdminApps.vue?02cdc186